<a
  class="asc-font-19"
  data-testid="about-the-data-link"
  data-html2canvas-ignore
  [routerLink]="['/workplace', workplaceUid, 'data-area', 'about-the-data']"
  (click)="setReturn()"
  >About the data</a
>
